import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { TreatmentsConsumerRenderProps, TreatmentsContext } from 'components/treatments/TreatmentsContext';
import BillDetailsInfo from 'components/bill/BillDetailsInfo';
import { MessageSourceProps, withMessages } from "react-message-source";
import { BillProvider } from 'components/bill/BillContext';
import BillDetailsHeader from 'components/bill/BillDetailsHeader';
import BillsToolbar from 'components/bill/BillsToolbar';

const StyledBillDetails = styled(Segment)`
  height: 292px;
  margin-bottom: 10px !important;
`;

const StyledBillHeader = styled.h4`
  flex: 1 100%;
  padding-bottom: 10px;
  margin-bottom: 0 !important;
`;


const BillDetails = (props: MessageSourceProps) => {

  const {selectedTreatment}: TreatmentsConsumerRenderProps = useContext(TreatmentsContext);

  return (
      <StyledBillDetails>
        <BillProvider>
          <BillDetailsHeader>
            <StyledBillHeader>{props.getMessage('bill.details')}</StyledBillHeader>
            <BillsToolbar selectedTreatment={selectedTreatment}/>
          </BillDetailsHeader>
          <BillDetailsInfo selectedTreatment={selectedTreatment}/>
        </BillProvider>
      </StyledBillDetails>
  )
};

export default withMessages(BillDetails);
